import {subFormNavDirections} from '../consts/grid';
import {Form, formsStore} from '../../../stores/Form';
import {isRTL} from '../../../Localization';
import {SidePanelSubforms} from '../consts/EntityTypes';

/**
 * Suggestion: move methods / actions based on store to this file
 * */

export const runSiblingSubform = async (direction: subFormNavDirections, currentForm: Form) => {
    const siblingForms = currentForm.parentForm.subFormsList.filter(
        subform => !SidePanelSubforms.includes(subform.Type)
    );
    const currFormIndex = siblingForms.findIndex(f => f.Ename === currentForm.ename);
    const leftForm = siblingForms[currFormIndex - 1];
    const rightForm = siblingForms[currFormIndex + 1];

    let siblingForm;
    if (direction === subFormNavDirections.right) {
        siblingForm = isRTL() ? leftForm : rightForm;
    } else if (direction === subFormNavDirections.left) {
        siblingForm = isRTL() ? rightForm : leftForm;
    }

    if (siblingForm) {
        await formsStore.currentScreen.runSubForm(
            siblingForm.Ename,
            currentForm.parentForm,
            siblingForm.IsText
        );
    }
};
